import { createSlice } from '@reduxjs/toolkit';
import { HeadcountChangesInitialState } from './headcountChanges.types';
import { HeadcountChangesKey } from './headcountChanges.const';
import {
  fetchHeadcountChanges,
  saveHeadcountChanges,
} from './headcountChanges.thunks';
import _ from 'lodash';

const initialState: HeadcountChangesInitialState = {
  headcountChanges: [],
  isLoading: false,
  previousHeadcountChanges: [],
  activeId: '',
};

export const headcountChangesSlice = createSlice({
  name: HeadcountChangesKey,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeadcountChanges.pending, (state, { meta }) => {
        state.isLoading = true;
        state.headcountChanges = [];
        state.activeId = meta.arg.activeId;
      })

      .addCase(fetchHeadcountChanges.fulfilled, (state, { payload }) => {
        state.headcountChanges = payload;
        state.isLoading = false;
      })

      .addCase(fetchHeadcountChanges.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(saveHeadcountChanges.pending, (state) => {
        state.previousHeadcountChanges = state.headcountChanges;
      })

      .addCase(saveHeadcountChanges.fulfilled, (state, { payload }) => {
        state.headcountChanges = payload;
        state.previousHeadcountChanges = [];
      })

      .addCase(saveHeadcountChanges.rejected, (state) => {
        if (state.previousHeadcountChanges)
          state.headcountChanges = state.previousHeadcountChanges;
        state.previousHeadcountChanges = [];
      });
  },
});
